export default [
    { icon: 'email', title: 'E-mail', description: 'contato@w.dental', link: 'mailto:contato@w.dental', },
    { icon: 'telefone', title: 'SAC', description: '0800 - 024 - 4330', link: 'tel:+5508000244330', },
    { icon: '', title: 'Televendas', description: '(21) 3030 - 3979', link: 'tel:+552130303979', },
]